import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import ReactLoading from "react-loading";
import withPermissions from "../../components/WithPermissions";
import KsoftServiceInvoicesTable from "../../components/Tables/KsoftServiceInvoicesTable";

class ServiceInvoices extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoad: false,
      filters: {
        status: '',
      }
    };
  }

  render() {
    const { filters } = this.state;

    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? 'block' : 'none' }}>
            <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div className="m-t-30">
                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid" />
              </div>
              <p>Yükleniyor</p>
              <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
            </div>
          </div>
          <div className="container-fluid">
            <PageHeader
              HeaderText="Giden Faturalar"
              Breadcrumb={[
                { name: "Servis Faturaları", navigate: "" },
                { name: "Giden Faturalar", navigate: "" },
              ]}
            />

            <div className="row clearfix">
              <div className="col-lg-12">
                <div className="card">
                  <div className="header">
                    <h2>
                      <i className="icon-doc text-primary"></i> Giden Faturalar
                    </h2>
                    <small className="text-muted">Servis işlemlerinden oluşturulan tüm faturalar</small>
                  </div>
                  <div className="body">
                    {/* Durum Badge'leri */}
                    <div className="row clearfix mb-3">
                      <div className="col-12">
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                          <button
                            className={`btn btn-sm ${filters.status === '' ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => this.setState({ filters: { status: '' } })}
                          >
                            <i className="icon-doc"></i> Tümü
                          </button>
                          <button
                            className={`btn btn-sm ${filters.status === 'draft' ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => this.setState({ filters: { status: 'draft' } })}
                          >
                            <i className="icon-note"></i> Taslak
                          </button>
                          <button
                            className={`btn btn-sm ${filters.status === 'running' ? 'btn-warning' : 'btn-outline-warning'}`}
                            onClick={() => this.setState({ filters: { status: 'running' } })}
                          >
                            <i className="icon-clock"></i> İşlemde
                          </button>
                          <button
                            className={`btn btn-sm ${filters.status === 'done' ? 'btn-success' : 'btn-outline-success'}`}
                            onClick={() => this.setState({ filters: { status: 'done' } })}
                          >
                            <i className="icon-check"></i> Tamamlanmış
                          </button>
                          <button
                            className={`btn btn-sm ${filters.status === 'cancel' ? 'btn-danger' : 'btn-outline-danger'}`}
                            onClick={() => this.setState({ filters: { status: 'cancel' } })}
                          >
                            <i className="icon-close"></i> İptal Edilmiş
                          </button>
                          <button
                            className={`btn btn-sm ${filters.status === 'error' ? 'btn-danger' : 'btn-outline-danger'}`}
                            onClick={() => this.setState({ filters: { status: 'error' } })}
                          >
                            <i className="icon-exclamation"></i> Hatalı
                          </button>
                          <button
                            className={`btn btn-sm ${filters.status === 'unknown' ? 'btn-secondary' : 'btn-outline-secondary'}`}
                            onClick={() => this.setState({ filters: { status: 'unknown' } })}
                          >
                            <i className="icon-question"></i> Diğer
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="row clearfix">
                      <div className="col-lg-12 col-md-12">
                        <KsoftServiceInvoicesTable status={filters.status} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = () => ({});

export default withPermissions(withRouter(connect(mapStateToProps, {})(ServiceInvoices)));

